import { render } from "./AdminSnippets.vue?vue&type=template&id=7c6fe28c&scoped=true"
import script from "./AdminSnippets.vue?vue&type=script&lang=js"
export * from "./AdminSnippets.vue?vue&type=script&lang=js"

import "./AdminSnippets.vue?vue&type=style&index=0&id=7c6fe28c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6fe28c"]])

export default __exports__